document.addEventListener('DOMContentLoaded', () => {
  initServiceFlowAccordion();

  // SP画面で元のボタンが画面外に出たタイミングで固定ボタンを表示
  initFloatingButton();
});

function initServiceFlowAccordion() {
  const textOuter = document.querySelector('.service-flow__text-outer');
  const showButton = document.querySelector('.service-flow__more--display');
  const hideButton = document.querySelector('.service-flow__more--hidden');

  if (!textOuter || !showButton || !hideButton) return;

  textOuter.style.maxHeight = getVisibleHeight() + 'px';
  showButton.addEventListener('click', (event) => {
    if (!event.target.classList.contains('service-flow__more--display')) return;

    textOuter.style.maxHeight = getInnerHeight() + 'px';

    document.querySelectorAll('.service-flow__gradient').forEach((el) => {
      el.style.display = 'none';
    });

    event.target.style.display = 'none';
    hideButton.style.display = 'flex';
  });

  hideButton.addEventListener('click', (event) => {
    if (!event.target.classList.contains('service-flow__more--hidden')) return;

    textOuter.style.maxHeight = getVisibleHeight() + 'px';

    document.querySelectorAll('.service-flow__gradient').forEach((el) => {
      el.style.display = 'block';
    });

    event.target.style.display = 'none';
    showButton.style.display = 'flex';
  });
}

function initFloatingButton() {
  // SP画面のみ実行
  if (window.innerWidth > 768) return;

  const originalButton = document.querySelector('.kv__auth-container .kv__auth-button--registration');
  const fixedButton = document.querySelector('.kv__auth-button--fixed');

  if (!fixedButton) return;

  // プロジェクト一覧では常時表示（SPのみ）
  if (!originalButton && isProjectsPage()) {
    fixedButton.classList.add('is-visible');
    return;
  }
  if (!originalButton) return;

  const toggleFixedButton = () => {
    const rect = originalButton.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

    if (isVisible) {
      fixedButton.classList.remove('is-visible');
    } else {
      fixedButton.classList.add('is-visible');
    }
  };

  // 初回チェック
  toggleFixedButton();

  // スクロールイベントで監視
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        toggleFixedButton();
        ticking = false;
      });
      ticking = true;
    }
  });

  // リサイズ時もチェック
  window.addEventListener('resize', () => {
    toggleFixedButton();
  });
}

function isProjectsPage() {
  return /^\/projects(\/|$)/.test(window.location.pathname);
}

// .service-flow__text-item の要素2つ目までの高さを取得
function getVisibleHeight() {
  const items = document.querySelectorAll('.service-flow__text-item');
  if (items.length < 3) return 0;
  let height = 0;

  for (let i = 0; i < 3; i++) {
    height += items[i].clientHeight;
  }

  return height;
}

function getInnerHeight() {
  const item = document.querySelector('.service-flow__text-inner');
  if (!item) return 0;
  return item.clientHeight;
}
